import { render } from "./SkillsetPage.vue?vue&type=template&id=52525d8a&scoped=true"
import script from "./SkillsetPage.vue?vue&type=script&lang=js"
export * from "./SkillsetPage.vue?vue&type=script&lang=js"

import "./SkillsetPage.vue?vue&type=style&index=0&id=52525d8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52525d8a"]])

export default __exports__